import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.CollapsePanel,
  title: 'Collapse Panel',
  category: ComponentCategory.Layout,
  droppable: true,
  showInLibrary: false,
};
